import { observer } from 'mobx-react-lite'
import { type JobScopeCustomItemViewModel } from '@/features/jobs/details/components/UpdateJobScopeDialog/ListItems/JobScopeCustomItem/JobScopeCustomItemViewModel'
import { JobScopeCustomItem } from '@/features/jobs/details/components/UpdateJobScopeDialog/ListItems/JobScopeCustomItem'
import { type Id } from '@/infra/id'

export interface JobScopeCustomItemContainerProps {
  vm: JobScopeCustomItemViewModel
  onRemove: (id: Id) => void
  itemTestId?: string
}

export const JobScopeCustomItemContainer = observer(
  function JobScopeCustomItemContainer({
    vm,
    onRemove,
    itemTestId,
  }: JobScopeCustomItemContainerProps) {
    return (
      <JobScopeCustomItem
        name={vm.name}
        price={vm.price}
        proPrice={vm.proPrice}
        currentQuantity={vm.currentQuantity}
        newQuantity={vm.newQuantity}
        isFromJobScope={vm.source === 'Job'}
        onRemove={() => onRemove(vm.id)}
        onQuantityChange={vm.setQuantity}
        itemTestId={itemTestId}
      />
    )
  },
)
